export default __webpack_public_path__ + "static/media/bracelet_5.e25987d6.webp";